import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { ScreenType } from '../../../../../../shared/enums/screen-type.enum'
import { CaseDetailComponent } from '../../../abacus/components/case-detail.component'
import { ResourceDefinition } from '../../../abacus/interfaces/resource-definition.interface'
import { AuthService } from '../../../abacus/services/auth.service'
import { BreadcrumbService } from '../../../abacus/services/breadcrumb.service'
import { FlashMessageService } from '../../../abacus/services/flash-message.service'
import { ResourceService } from '../../../abacus/services/resource.service'
import { scanDefinition } from '../scan.definition'

@Component({
  templateUrl: './scan-detail.component.html',
  styleUrls: ['./scan-detail.component.scss']
})
export class ScanDetailComponent extends CaseDetailComponent implements OnInit {
  ScreenType = ScreenType
  definition: ResourceDefinition = scanDefinition
  isQuickFlow: boolean

  constructor(
    breadcrumbService: BreadcrumbService,
    resourceService: ResourceService,
    flashMessageService: FlashMessageService,
    activatedRoute: ActivatedRoute,
    private authService: AuthService
  ) {
    super(
      breadcrumbService,
      resourceService,
      flashMessageService,
      activatedRoute
    )
  }

  async ngOnInit(): Promise<void> {
    await this.initDetailView()

    this.isQuickFlow = !(await this.authService.can('canDoSlowFlowScans'))
  }
}
